<template>
	<UiElement v-show="visible && isFirstPage" class="page" :settings="appearance.body.settings">
		<div>
			<AppHeader
				hide-btn1
				hide-btn2
			/>

			<div class="flex-grow-1">
				<div class="d-flex align-items-center justify-content-center flex-grow-1 position-absolute w-100 h-100 top-0 start-0 z-3" style="background: rgba(255,255,255,.7)">
					<UiElement
						class="d-flex flex-column align-items-center"
						:settings="card1"
					>
						<UiText :settings="heading1" :content="translations?.orderHere || '{orderHere}'" />

						<router-link :to="makePath('/products')" class="w-100 text-decoration-none">
							<UiButton
								:settings="button1"
								class="w-100"
								:content="translations?.toBill || '{toBill}'"
							>
							</UiButton>
						</router-link>

						<router-link :to="makePath('/products')" class="w-100 text-decoration-none">
							<UiButton :settings="button2" class="w-100" :content="translations?.toTakeAway || '{toTakeAway}'" />
						</router-link>
					</UiElement>
				</div>
			</div>
		</div>
	</UiElement>
</template>

<script setup>
	import { ref, computed, onMounted } from 'vue';
	import { useRouter } from 'vue-router';
	import { storeToRefs } from 'pinia';
	import { useKioskRoute } from '@/composables/useKioskRoute';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';

	import { useThemeStore } from '@/stores/useThemeStore';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import AppHeader from '@/components/AppHeader.vue';

	const { makePath } = useKioskRoute();

	const router = useRouter();

	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const visible = ref(false);

	const { theme } = storeToRefs(themeStore);
	const { translations } = storeToRefs(translationsStore);

	const appearance = computed(() => theme.value.pages.start.appearance);
	const elements = computed(() => theme.value.pages.start.elements);
	const options = computed(() => theme.value.pages.start.options);

	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));
	const card1 = useInheritedSettings(computed(() => elements.value?.card1));
	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const isFirstPage = computed(() => {
		return options.value?.visibility?.value === true || options.value?.visibility.value === 'true';
	})

	onMounted(() => {
		if (window.self === window.top) {
			if (!isFirstPage.value) {
				router.push({
					path: makePath('/products'),
					query: { noTransition: '1' }
				});
			}
		}

		visible.value = true;
	});
</script>